
<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading || !users">
    <div>
      <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>
  <div class="p-2 h-100 w-100 relative scrollable pb-5">
<mat-tab-group>
  <mat-tab label="Users">
    <div class="p-2 h-100 w-100 relative scrollable pb-5">
      <div class="d-flex align-items-center">
        <h4 class="mr-3">Filter</h4>
      <mat-radio-group class="mt-2 mb-2" [(ngModel)]="filter" (change)="updateFilter()">
        <mat-radio-button class="mr-2" value="all">All</mat-radio-button>
      <mat-radio-button class="mr-2" value="subscribers">Subscribers</mat-radio-button>
    </mat-radio-group>
    </div>
    <table *ngIf="dataSource?.data" mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100">
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef class="parent-col"> Name </th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center ">
            <div>
              <div class="initials">{{element.Name ? element.Name[0] : ''}}</div>
            </div>
            <div>
              <p class="ml-2 m-0">{{element.Name}}</p>
            </div>
          </div>
        </td>
      </ng-container>
          <ng-container matColumnDef="Mobile">
            <th mat-header-cell *matHeaderCellDef> Mobile </th>
            <td mat-cell *matCellDef="let element"> {{element.Mobile}} </td>
          </ng-container>
          <ng-container matColumnDef="Email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
          </ng-container>
          <ng-container matColumnDef="Notifications">
            <th mat-header-cell *matHeaderCellDef> Notifications </th>
            <td mat-cell *matCellDef="let element"> {{element.EmailNotifications ? 'Email': ''}} </td>
          </ng-container>
          <ng-container matColumnDef="Subscription">
            <th mat-header-cell *matHeaderCellDef> Subscription </th>
            <td mat-cell *matCellDef="let element"> 
              <div *ngIf="element.Subscription" class="d-flex flex-column">
              <span>{{element.Subscription?.amount | currency: "R"}}</span>
              <span>{{element.PaymentConfirmed ? 'Active' : 'Pending'}} </span>
              <span *ngIf="element.Subscription?.billing_date">Start: {{element.Subscription?.billing_date}} </span>
              <span *ngIf="element.Subscription?.expiry_date">Expiry: {{element.Subscription?.expiry_date}} </span>

              <button
                *ngIf="element.Subscription && !element.CancelationRequest && !element.PaymentConfirmed"
                (click)="confirmSubscription(element.id)"
                mat-raised-button
                color="primary"
                class="m-3"
              >
                Confirm payment
              </button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
    
            <td [ngClass]="'text-center'" mat-cell *matCellDef="let element">
              <div class="d-flex flex-row">
              <ng-container *ngIf="filter === 'subscribers' && element.Subscription?.expiry_date">
                <button *ngIf="checkExpiry(element.Subscription.expiry_date)" mat-raised-button (click)="sendRenewalNotice(element)">Send Renew Notice</button>
              </ng-container>
                <button
                  (click)="openParent(element.id)"
                  title="view"
                  type="button"
                  class="btn btn-outline-primary btn_yellow_mobile btn_yellow"
                >
                Open
                </button>
              </div>
            </td>
          </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator #parentsPaginator
            *ngIf="dataSource?.data"
            [length]="userCount"
            [pageSize]="displayLimit"
            [pageIndex]="page"
            [pageSizeOptions]="[5, 10, 25, 100]"
            aria-label="Select page"
            (page)="pageUsers($event)">
    </mat-paginator>
  
  </div>
  </mat-tab>
  <mat-tab label="Cancelation Requests">
    <div class="row m-3 p-3">
      <h2>Please make sure to sign into PayFast and cancel the subscription before confirming the cancelation here.</h2>
    </div>
    <div *ngFor="let request of requests" class="row border-primary m-3 p-3">
      <div class="col-md-4">
        <div class="d-flex flex-column">
          <span>{{request.Name}} {{request.Surname}}</span>
          <span>{{request.Email}}</span>
          <span>{{request.Mobile}}</span>
        </div>
        <br>
        <h3>Package: {{request.Subscription?.amount | currency: "R"}}</h3>
        <p>Reason: {{request.CancelationRequest?.reason}}</p>
      </div>
      <div class="col-md-4">
        <button
        (click)="removeRequest(request.id)"
        mat-stroked-button
        class="m-3 text-danger"
      >
        Delete request
      </button>
        <button
        (click)="confirmCancelation(request.id)"
        mat-raised-button
        color="primary"
        class="m-3 text-white"
      >
        Confirm Cancelation
      </button>
      </div>
</div>
  </mat-tab>
</mat-tab-group>
</div>